import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { Api } from "../../utils/api";
import { MaterialSelectFormik } from "../components/select-field.component";
import { DatePicker } from "../components/datetime-picker.component";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button/Button";
import { REQUEST_PERIODS } from "../utils/cancel.constants";

const validationSchema = object().shape({});

const REQUEST_STATE_OPTIONS = [
  { value: "new", label: "Novo" },
  { value: "pending", label: "Pendente" },
  { value: "active", label: "Em Curso" },
  { value: "admitted", label: "Admitido" },
  { value: "preadmitted", label: "Pré-Confirmado" },
  { value: "canceled", label: "Cancelado" },
  { value: "standby", label: "Standby" },
  { value: "not_accepted", label: "Por Aceitar" },
];

const request_state_promise = async () => {
  return REQUEST_STATE_OPTIONS;
};

const request_periods_promise = async () => {
  return REQUEST_PERIODS;
};

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

export const adminOptionsPromise = (name) => {
  const api = new Api();
  return api
    .get("/admins", { name, admin_group_ids: [4, 5], active: true })
    .then((res) => res.data)
    .then((data) => {
      const newData = data || [];
      newData.push({ id: "me", name: "Eu" });
      return newData;
    })
    .then(optionsToSelect);
};

const userOptionsToSelect = (options) => {
  return options.map((option) => ({
    value: option.id,
    label: `${option.name} - ${option.email}`,
  }));
};

export const userOptionsPromise = (name) => {
  const api = new Api();
  return api
    .get("/users", { name })
    .then((res) => res.data)
    .then(userOptionsToSelect);
};

const countiesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/counties", {}, true)
    .then((res) => res.data)
    .then(optionsToSelect);
};

const parishesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/parishes", {}, true)
    .then((res) => res.data)
    .then(optionsToSelect);
};

const entitiesOptionsPromise = (name) => {
  const api = new Api();
  return api
    .get("/entities", { search: name }, true)
    .then((res) => res.data.entities)
    .then(optionsToSelect);
};

//atençao que aqui ele passa o id do establishments_valences e nao do establishments
const establishmentValenceOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/establishments", { input_filter_establishments: true })
    .then((res) => res.data)
    .then(optionsToSelect);
};

const districtsOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/districts", {}, true)
    .then((res) => res.data)
    .then(optionsToSelect);
};

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

const getInitialSearchValues = () => {
  return {
    email: "",
    elderly_name: "",
    counties: "",
    districts: "",
    first_county: "",
    first_parish: "",
    min_price: "",
    max_price: "",
    request_since: null,
    request_date: null,
    request_until: null,
    request_state: "",
    request_type: "",
    request_period: "",
    visited_since: null,
    proposed_visit_date_since: null,
    proposed_admission_date_since: null,
    is_urgent: null,
    admin_id: "",
    entity: "",
    establishment_valence: "",
    payed_subscription: null,
    direct_requests: null,
    stay_since: null,
    stay_until: null,
  };
};

export const RequestFilterForm = ({ searchValues, onChange }) => (
  <div style={{ padding: 20 }}>
    <Grid item md={12}>
      <Formik
        initialValues={{
          ...searchValues,
        }}
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleSubmitting(onChange)}
        render={({
          values,
          errors,
          status,
          touched,
          dirty,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          handleReset,
          resetForm,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Grid item md={12}>
                <Grid container spacing={2}>
                  <Grid item md={3}>
                    <Field
                      name="email"
                      label="Email de contacto do utilizador"
                      type="text"
                      variant={values.email ? "filled" : "outlined"}
                      margin="normal"
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="elderly_name"
                      label="Nome do Idoso"
                      type="text"
                      variant={values.elderly_name ? "filled" : "outlined"}
                      margin="normal"
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="min_price"
                      label="Valor mínimo de procura da família"
                      type="number"
                      variant={!values.min_price ? "outlined" : "filled"}
                      margin="normal"
                      inputProps={{ step: 50 }}
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="max_price"
                      label="Valor máximo de procura da família"
                      type="number"
                      variant={values.max_price ? "filled" : "outlined"}
                      margin="normal"
                      inputProps={{ step: 50 }}
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="request_since"
                      label="A partir de"
                      variant={values.request_since ? "filled" : "outlined"}
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="request_until"
                      label="Até"
                      variant={values.request_until ? "filled" : "outlined"}
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3} className="mt-3">
                    <MaterialSelectFormik
                      name="request_state"
                      label="Estado do pedido"
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={values.request_state}
                      optionsFetcher={request_state_promise}
                    />
                  </Grid>
                  {/* <Grid item md={3} className="mt-3">
                <MaterialSelectFormik
                  name="request_type" 
                  placeholder="Tipo de pedido"
                  label="Tipo de pedido"
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={values.request_type}
                  optionsFetcher={request_type_promise}
                />
              </Grid> */}
                  <Grid item md={3} className="mt-3">
                    <MaterialSelectFormik
                      name="request_period"
                      placeholder="Data pretendida de admissão"
                      label="Data Pretendida"
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={values.request_period}
                      optionsFetcher={request_periods_promise}
                    />
                  </Grid>
                  <Grid item md={3} className="mt-3">
                    <Field
                      name="admin_id"
                      label="Consultor"
                      search
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={"" + values.admin_id}
                      optionsFetcher={adminOptionsPromise}
                      component={MaterialSelectFormik}
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="proposed_admission_date_since"
                      label="Pode Ter Sido Admitido desde"
                      margin="normal"
                      variant={
                        values.proposed_admission_date_since
                          ? "filled"
                          : "outlined"
                      }
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="visited_since"
                      label="Visitou desde (visitas realizadas)"
                      variant={values.visited_since ? "filled" : "outlined"}
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={3}>
                    <Field
                      name="proposed_visit_date_since"
                      label="Pode ter visitado desde (visitas marcadas)"
                      variant={
                        values.proposed_visit_date_since ? "filled" : "outlined"
                      }
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={6} className="mt-3">
                    <MaterialSelectFormik
                      name="entity"
                      placeholder="counties"
                      label="Entidade (empresa responsável pelo equipamento)"
                      search
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={values.entity}
                      optionsFetcher={entitiesOptionsPromise}
                    />
                  </Grid>
                  <Grid item md={6} className="mt-3">
                    <MaterialSelectFormik
                      name="counties"
                      placeholder="counties"
                      label="Pedidos com equipamento no concelho"
                      onChange={setFieldValue}
                      isMulti
                      onBlur={setFieldTouched}
                      value={values.counties}
                      optionsFetcher={countiesOptionsPromise}
                    />
                  </Grid>
                  <Grid item md={6} className="mt-3">
                    <MaterialSelectFormik
                      name="districts"
                      label="Pedidos com equipamento no distrito"
                      onChange={setFieldValue}
                      isMulti
                      onBlur={setFieldTouched}
                      value={values.districts}
                      optionsFetcher={districtsOptionsPromise}
                    />
                  </Grid>
                  <Grid item md={6} className="mt-3">
                    <MaterialSelectFormik
                      name="first_county"
                      label="Primeira zona de referência da família (Concelho)"
                      onChange={setFieldValue}
                      limit={20}
                      onBlur={setFieldTouched}
                      value={values.first_county}
                      optionsFetcher={countiesOptionsPromise}
                    />
                  </Grid>
                  <Grid item md={6} className="mt-3">
                    <MaterialSelectFormik
                      name="first_parish"
                      placeholder="first_parish"
                      label="Primeira zona de referência da família (Freguesia)"
                      onChange={setFieldValue}
                      limit={20}
                      onBlur={setFieldTouched}
                      value={values.first_parish}
                      optionsFetcher={parishesOptionsPromise}
                    />
                  </Grid>
                  <Grid item md={6} className="mt-3">
                    <MaterialSelectFormik
                      name="establishment_valence"
                      placeholder="establishment_valence"
                      label="Equipamentos (termo utilizado para lar)"
                      search
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      defaultValue={""}
                      limit={10}
                      value={values.establishment_valence}
                      optionsFetcher={establishmentValenceOptionsPromise}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <Field
                      name="stay_since"
                      label="Tempo de estadia desde"
                      variant={values.stay_since ? "filled" : "outlined"}
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={6}>
                    <Field
                      name="stay_until"
                      label="Tempo de estadia até"
                      variant={values.stay_until ? "filled" : "outlined"}
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={2}>
                    <Field
                      name="notes_added_since"
                      label="Com notas desde"
                      variant={values.notes_added_since ? "filled" : "outlined"}
                      margin="normal"
                      onChange={setFieldValue}
                      component={DatePicker}
                      fullWidth
                    />
                  </Grid>
                  <Grid item md={2} className="mt-4">
                    <Field
                      name="payed_subscription"
                      Label={{ label: "Com plano pago" }}
                      component={CheckboxWithLabel}
                      onChange={setFieldValue}
                      value={"" + values.payed_subscription}
                      disabled={values.request_state === "new"}
                    />
                  </Grid>
                  <Grid item md={2} className="mt-4">
                    <Field
                      name="direct_requests"
                      Label={{ label: "Pedidos Dirigidos" }}
                      component={CheckboxWithLabel}
                      onChange={setFieldValue}
                      value={"" + values.direct_requests}
                      disabled={values.request_state === "new"}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Button
                className="mt-3"
                variant="contained"
                type="submit"
                size="small"
                onClick={handleSubmit}
              >
                Filtrar
              </Button>
              <Button
                className="mt-3 ml-3"
                variant="contained"
                type="reset"
                size="small"
                onClick={() => resetForm(getInitialSearchValues())}
              >
                Limpar
              </Button>
            </form>
          );
        }}
      />
    </Grid>
  </div>
);
